import { PDFLayout } from "ui/components/PDF";
import PDFTable from "ui/components/PDF/Table";
import usePDFContasRecorrentesColumns from "./hooks/usePDFContasRecorrentesColumns";
import { View } from "@react-pdf/renderer";
import ResumoPorCategoria from "components/Relatorio/ResumoPorCategoria";
import { ContasRecorrentesPdfResponse } from "core/features/conta-recorrente/typings";
import { ContasRecorrentesFields } from "core/features/relatorios/typings";
import moment from "moment";
import { OperacaoEnum } from "core/resources/enums/conta";
import { formatMoney } from "infra/helpers/number";
import { capitalizeFirstLetter } from "infra/helpers/capitalizeFirstLetter";

interface PDFContasRecorrentesProps {
  data: ContasRecorrentesPdfResponse;
  selectedFields?: ContasRecorrentesFields[];
  mes?: string;
  includeDocumentWrapper?: boolean;
  operacao?: OperacaoEnum;
}

function PDFContasRecorrentes({
  data,
  selectedFields,
  mes,
  includeDocumentWrapper = true,
  operacao,
}: PDFContasRecorrentesProps) {
  const columns = usePDFContasRecorrentesColumns();

  return (
    <PDFLayout
      includeDocument={includeDocumentWrapper}
      fontSize={8}
      headerProps={{
        logo: data?.logo!,
        tenant: data?.nomeTenant!,
        title:
          operacao === OperacaoEnum.Receita
            ? "Receitas recorrentes"
            : "Despesas recorrentes",
        subTitle: mes
          ? capitalizeFirstLetter(moment(mes, "YYYY-MM").format("MMMM YYYY"))
          : undefined,
        cards: [
          {
            title: "Total",
            value: formatMoney(data.total),
          },
        ],
      }}
      footerProps={{
        tenant: data?.nomeTenant!,
        logo: data?.logoAdm!,
        endereco1: data?.endereco1!,
        endereco2: data?.endereco2!,
      }}
      orientation="landscape"
    >
      <PDFTable
        columns={columns}
        data={data.items}
        tableHeaderVariant="rowLike"
      />

      {data && selectedFields?.includes("resumoContaCategoria") ? (
        <View
          style={{
            marginTop: 32,
          }}
        >
          <ResumoPorCategoria data={data} />
        </View>
      ) : null}
    </PDFLayout>
  );
}

export default PDFContasRecorrentes;
